import { render, staticRenderFns } from "./LogsHighlight.vue?vue&type=template&id=55840e26&scoped=true"
import script from "./LogsHighlight.vue?vue&type=script&lang=js"
export * from "./LogsHighlight.vue?vue&type=script&lang=js"
import style0 from "./LogsHighlight.vue?vue&type=style&index=0&id=55840e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55840e26",
  null
  
)

export default component.exports